/* Storefront filter query helper. Keeps repeated filter.* params. */
(function (root) {
  function parse(search) {
    var params = {};
    var filters = [];
    var query = search || '';
    if (query.charAt(0) === '?') query = query.slice(1);
    if (!query) return { params: params, filters: filters };

    var pairs = query.split('&');
    for (var i = 0; i < pairs.length; i++) {
      if (!pairs[i]) continue;
      var parts = pairs[i].split('=');
      var key = decodeURIComponent(parts[0].replace(/\+/g, ' '));
      var raw = parts.length > 1 ? parts.slice(1).join('=') : '';
      var value = key === 'constraint'
        ? decodeURIComponent(raw)
        : decodeURIComponent(raw.replace(/\+/g, ' '));
      if (key.indexOf('filter.') === 0) filters.push([key, value]);
      else params[key] = value;
    }
    return { params: params, filters: filters };
  }

  function encodePair(key, value) {
    var encoded = encodeURIComponent(String(value));
    if (key === 'constraint') encoded = encoded.replace(/%2B/g, '+');
    return encodeURIComponent(key) + '=' + encoded;
  }

  function build(params, filters) {
    var parts = [];
    var key;
    params = params || {};
    filters = filters || [];
    for (key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) continue;
      if (params[key] === undefined || params[key] === null || params[key] === '') continue;
      parts.push(encodePair(key, params[key]));
    }
    for (var i = 0; i < filters.length; i++) {
      parts.push(encodePair(filters[i][0], filters[i][1]));
    }
    return parts.join('&');
  }

  root.cmhfQuery = { parse: parse, build: build };

  if (typeof document === 'undefined') return;

  function prepare(form) {
    var inputs = form.querySelectorAll('input[type="text"]');
    var i;
    for (i = 0; i < inputs.length; i++) {
      var value = inputs[i].value.replace(/,/g, '').trim();
      inputs[i].value = value;
      if (!value) inputs[i].disabled = true;
    }
    var current = new URLSearchParams(location.search);
    ['view', 'type'].forEach(function (key) {
      if (!current.get(key) || form.querySelector('[name="' + key + '"]')) return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = key;
      hidden.value = current.get(key);
      form.appendChild(hidden);
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.form || target.form.id !== 'FacetFiltersForm' || target.type === 'text') return;
    prepare(target.form);
    target.form.submit();
  });

  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== 'FacetFiltersForm') return;
    prepare(event.target);
  });
})(typeof window !== 'undefined' ? window : global);
